import React, { useContext } from "react";

import DataContext from "../../../../../../../../context/DataContext";
import AvailabilityTable from "../../components/AvailabilityTable";

export default function ClientAvailability({ caseObj }) {
  const { userRoles } = useContext(DataContext);

  return (
    <div className="flex w-full flex-col items-start p-1">
      <h2 className="mb-5 text-sm uppercase text-gray-400">{"Client Availability: "}</h2>

      <div className="mb-5 max-h-[90vh] w-full overflow-y-auto">
        {!userRoles.permissions.includes("users.view_usercontacthours") || !caseObj ? (
          <h2 className="my-2 text-center text-gray-500 underline">
            Content details not available for this account at this time
          </h2>
        ) : (
          <AvailabilityTable caseObj={caseObj} />
        )}
      </div>
    </div>
  );
}
